<template>
  <div class="home">
    <div class="job-category-top">
      <div class="blue-back">
        <div class="wrap blue-inner">
          <p class="job-category-title">Corder</p>
          <h1 class="job-category-sub">ウェブサイト制作（未経験者～経験2年未満）の求人情報</h1>
        </div>
      </div>
      <div class="wrap">
        <img
          alt="ウェブサイト制作トップ"
          src="@/assets/job-category/GH-kyujin-website001.webp"
          class="top"
        />
        <div class="text">
          <p>
            HTML/CSSやWordPressによるウェブサイト制作の未経験者、または、経験年数が2年未満の人を対象にしたお仕事です。<br>ウェブサイト制作のスキルはあるが実務経験がない、または、浅い人で、ウェブサイト制作のお仕事がしたい人は、岐阜市にある株式会社グレイトヘルプの求人をぜひチェックしてみてください。<br>出勤曜日が自由、勤務時間が自由、無駄な拘束時間なしなど、仕事において時間的な制約がある人が働きやすい勤務条件と職場環境を整えています。
          </p>
          <img src="@/assets/ezgif.com-gif-maker-A.png" alt="説明イラスト" />
        </div>
        <img
          src="@/assets/ezgif.com-gif-maker-B.png"
          alt="雲"
          class="illust-b"
        />
      </div>
    </div>

    <div class="recommendation">
      <HomeRecommendation />
    </div>

    <div class="space-top-70 space-top-130">
      <HomeWorkPlace />
    </div>

    <div class="space-top-130">
      <HomeWorkEnvironment />
    </div>

    <div class="space-top-130">
      <HomeWorkEnvironment2 />
    </div>

    <div class="space-top-130">
      <JobCategoryAboutWork
        :topImg="false"
        :middleImg="true"
        :imgPath1="'GH-kyujin-website002.webp'"
        :imgPath2="'GH-kyujin-website003.webp'"
        :subTitle="'ウェブサイト制作のお仕事について'"
        :detail="'当職は、以下の人を対象にしています。<ul><li>講座や書籍などでウェブサイト制作（HTML/CSS）の勉強をしていて、スキルはあるが実務経験がない人</li><li>ウェブサイト制作の実務経験が2年未満でウェブサイト制作のスキルがある人</li></ul><br>仕事内容は以下です。<ul><li>ウェブサイトの更新業務（テキストや画像の差し替え、HTML/CSSの修正、など）</li><li>ウェブサイトのコーディングの補助業務</li><li>ウェブサイトのコーディングの主担当業務</li><li>ウェブサイト制作以外の業務（主にマーケティングの補助業務）</li></ul><br>入社時の保有のスキルを考慮して、業務を割り振り、対応していただきます。仕事の前提として、ウェブサイト制作に関連する業務だけをしていただくわけではございません。会社から指定する、いかなる業務も対応していただきます。具体的には以下のような業務となっていて、ウェブサイトのコーディングの仕事ではありませんが、ウェブマーケティングに関連するお仕事です。<ul><li>ホームページやECサイトの媒体制作のサポート業務（調査・マーケティング、コンテンツ設計・制作のサポート）</li><li>ホームページやECサイトの完成品の外観のチェック</li><li>システムの動作テストと完成品の外観のチェック</li><li>ECサイトの商品の価格改定、在庫数の変更、クーポン発行</li><li>SNS運用のサポート業務</li><li>ネットでの調査と調査結果の資料化（調査方法について明確な指示あり）</li></ul><br>ウェブサイト制作のスキルが高くなるにつれて、業務として対応していただくウェブサイト制作の範囲が広くなり、最終的には1サイトすべてを対応することを目指します。このように、実務経験がない、または、浅い人が実務としてウェブサイト制作に関する業務をして、実務経験を通して、少しずつ対応する範囲を広くしていくお仕事です。'"
        :skill="'入社の段階で実務経験は問いませんが、ウェブサイト制作（HTML/CSS）に関するスキルと知識は必須です。入社の選考では、スキルと知識を確認します。現状で、知識とスキルがない人、これから勉強したい人は応募不可です。また、先輩従業員の指導のもと、弊社が指定する方法・環境でウェブサイトのコーディングをしていただきます。そのため、職場に合わせる柔軟性と素直さは必須です。<br><br>重要な前提として、「ウェブサイト制作を学べる学校」ではありません。ウェブサイト制作以外の業務も多数していただきます。ウェブサイト制作以外のお仕事は、マーケティング関連がメインのため、ウェブサイト制作に関連する知識としてプラスになります。入社後も自発的にご自宅などでも学習する姿勢がある人を求めています。勤務時間中に仕事を通してのみ学ぶという姿勢では、スキルの習得速度が遅く、成長が限られ、また、その姿勢・スタンスは、ウェブサイト制作という日々進化する職種に合わないと考えているためです。率直な言葉ですが、仕事において、以下に該当する人はご応募をお控えください。また、入社後に該当した場合は、割り当てる業務内容を制限します。弊社のウェブサイト制作の実務を遂行するにあたり、重要なことだと位置づけているためです。<ul><li>自身のサイト制作方法にこだわる</li><li>業務対応の柔軟性がない</li><li>ウェブサイト制作以外の業務はしたくない</li><li>仕事よりも自分の学びが優先</li><li>会社でしか勉強する気がない</li><li>上司や指導者に対する敬意や配慮がない</li></ul><br>将来のビジョンとして、以下をお考えの人を対象にしています。<ul><li>弊社の仕事を通してスキルを身につけて、弊社で中長期的に仕事をしていきたい人</li><li>弊社の仕事を通してスキルを身につけて、将来は独立希望だが、独立後も弊社と協業を希望する人</li></ul><br>以下のような人はご応募をお控えください。<ul><li>弊社の仕事を通してスキルを身につけて、転職によるキャリアアップを目指したい人</li><li>弊社の仕事を通してスキルを身につけて、弊社とは関係のない立場での独立を目指したい人</li><li>弊社の仕事を通してスキルを身につけて、弊社と競合する立場での独立を目指したい人</li></ul>'"
        :experience="'カンタンな業務から担当し、ご自身で1からサイトを制作するスキルが身につき、かつ、十分な実務経験を積むことができます。<br><br>また、サイト制作の技術者として以下を身につけることもできます。<ul><li>CSSのより効率的な書き方（SCSS）</li><li>WordPress</li><li>フレームワーク（Vue.js）の正しい使い方</li><li>動くウェブサイト（アニメーションデザイン）の作り方</li></ul><br>弊社はウェブマーケティングに強みがあり、制作する媒体を通して事業主様の売上アップや集客増などの業績向上を支援しています。そのため、弊社でウェブサイト制作の業務を経験することで、ただ媒体やシステムを構築するだけでなく、売上アップや集客増などのマーケティングを考慮した媒体やシステムの構築スキルが身につきます。特にSEOを考慮したホームページの制作ノウハウが身につくことは、大きなメリットです。'"
      />
    </div>

    <div class="space-top-130 space-top-70">
      <JobCategoryInfo
        :job="'ウェブサイト制作（未経験者～経験2年未満）'"
        :content="'HTML/CSSによるホームページの制作業務、会社から指示がある一切の業務<br>※詳細は当ページ上部の「仕事内容」に記載'"
        :condition="'<ul><li>講座や書籍などでウェブサイト制作（HTML/CSS）の勉強をしていて、スキルはあるが実務経験がない人</li><li>ウェブサイト制作の実務経験が2年未満でウェブサイト制作のスキルがある人</li></ul>※詳細は当ページ上部の「必要となる対応・能力・スキル」に記載'"
        :pay="'1,065円～1,250円<br>※基本的に時給は1,065円で、入社時の保有スキルと実務経験によって優遇する場合があります。'"
        :raise="'20円〜100円/時（社内の全職種による実績）'"
        :pg="false"
        :first="true"
        :wdn="false"
        :isNonInsurableEmployment="true"
      />
    </div>
    <div class="space-top-130 space-top-70">
      <HomeSelectionSchedule />
    </div>

    <div class="space-top-130 space-top-70">
      <HomeQa :qaBoxList="qaBoxList" />
    </div>

    <div class="space-top-130 space-top-70">
      <HomeContact id="contact" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import HomeRecommendation from "@/components/Home/Recommendation.vue";
import HomeWorkPlace from "@/components/Home/WorkPlace.vue";
import HomeWorkEnvironment from "@/components/Home/WorkEnvironment.vue";
import HomeWorkEnvironment2 from "@/components/Home/WorkEnvironment2.vue";
import JobCategoryAboutWork from "@/components/JobCategory/AboutWork.vue";
import JobCategoryInfo from "@/components/JobCategory/Info.vue";

import HomeSelectionSchedule from "@/components/Home/SelectionSchedule.vue";
import HomeQa from "@/components/Home/Qa.vue";
import HomeContact from "@/components/Home/Contact.vue";

export default {
  name: "Home",
  components: {
    HomeRecommendation,
    HomeWorkPlace,
    HomeWorkEnvironment,
    HomeWorkEnvironment2,
    JobCategoryAboutWork,
    JobCategoryInfo,
    HomeSelectionSchedule,
    HomeQa,
    HomeContact,
  },
  props: {},
  data() {
    return {
      qaBoxList: [
                {
          id: 1,
          qestion: "自由出勤の仕組みについて教えてください。自由に休めますか？",
          answer:
            "他の従業員と業務の進捗への影響がないことを前提にした勤務時間の自由となります。入社時に、1週間あたりの勤務時間（週15時間～）を決定します。この勤務時間において、出勤曜日と勤務時間が自由という仕組みです。出勤予定日にお休みをとった場合は、原則として1週間以内に欠勤分の勤務時間を補填する勤務をしていただいています（欠勤の理由と業務状況によっては補填なしの場合もあり）。お子様の長期休暇時は、事前の申請と調整によって、勤務日数・勤務時間を通常よりも減らすことは可能です。この条件を満たせる方のみご応募可能となっています。",
        },
        {
          id: 2,
          qestion: "未経験でも応募可能でしょうか？",
          answer:
            "未経験者も応募可能です。当ページ上部の「必要となる対応・能力・スキル」に記載していますので、ご確認をお願いします。",
        },
        {
          id: 3,
          qestion: "使用する端末のOSは何でしょうか？",
          answer: "WindowsまたはMacでご希望の方の端末をご用意します。",
        },
        {
          id: 4,
          qestion: "副業・フリーランスでの応募も可能でしょうか？",
          answer:
            "平日9時30分～17時のご希望の曜日・時間帯で週15時間以上の勤務ができる場合は応募可能です。",
        },
        {
          id: 5,
          qestion: "グレイトヘルプに勤務しながら、副業は可能でしょうか？",
          answer:
            "可能です。ただし、弊社での勤務がメインであることを前提とします。また、弊社の事業内容と競合する仕事などは制限がある場合がございます。",
        },
        {
          id: 6,
          qestion: "業務中に車を運転することはありますか？",
          answer:
            "職種によってはあります。頻度はまれです。社有車があります。ご自身のお車を使う場合は手当を支給しています。業務中にお車の運転ができないことを前提とした応募も可能ですので、応募書類にその旨をご記載ください。",
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["rootUrl"]),
  },
  watch: {},
  methods: {},
  created() {},
};
</script>
<style lang="scss" scoped>
.job-category-top {
  .blue-back {
    background-color: var(--main);
    .blue-inner {
      position: relative;
      padding-top: 100px;
      padding-bottom: 150px;
      @media screen and (max-width: 767px) {
        margin-top: 70px;
      }
      h1,
      p {
        color: white;
      }
    }
  }
  .top {
    margin-top: -120px;
  }
  .text {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-top: 30px;
    @media screen and (max-width: 767px) {
      display: block;
    }
    p {
      width: 80%;
      margin-bottom: 30px;
      @media screen and (max-width: 767px) {
        width: 100%;
      }
    }
    img {
      width: 250px;
      @media screen and (max-width: 767px) {
        width: 200px;
        margin-left: calc(100% - 200px);
      }
    }
  }
  .illust-b {
    width: 200px;
    position: absolute;
    top: 60%;
    left: 15%;
    @media screen and (max-width: 1024px) {
      display: none;
    }
  }
}

.recommendation {
  background-color: var(--sub);
}
</style>